import React, { useEffect } from "react";
import "./Dashboard.scss";
import InfoCard from "../../components/InfoCard/InfoCard";
import reports from "../../images/reports.svg";
import transactions from "../../images/transactions.svg";
import user from "../../images/user.svg";
import world from "../../images/world.svg";
import LineCharts from "../../components/LineChart/LineCharts";
import TransactionList from "../../components/TransactionList/TransactionList";
import { useDispatch, useSelector } from "react-redux";
import { getUsers } from "../../util/API/customers";
import { getUserList } from "../../store/redux/users";

const Home = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    async function getList() {
      let userList = await getUsers();
      dispatch(getUserList({ users: userList }));
    }
    getList();
  }, []);

  const customerList = useSelector((state) => state.usersList.users);
  const customerCount = customerList.count;
  // const newCustomersList =
  //   customerList.payload?.slice(Math.max(customerList.payload.length - 3, 0)) ||
  //   [];

  return (
    <div className="page-container">
      <div className={`page-title`}>Dashboard</div>

      <div className="top-container">
        <div className="top-container-left">
          <div className="infocard-container">
            <InfoCard image={reports} title={"Reports"} number={74} />
            <InfoCard
              image={transactions}
              title={"Transactions"}
              number={1598}
            />
            <InfoCard image={user} title={"Customers"} number={customerCount} />
            <InfoCard image={world} title={"Agents"} number={97} />
          </div>
          <div className="linechart-container">
            <LineCharts />
          </div>
        </div>
        <div className="top-container-right">{<TransactionList />}</div>
      </div>
      <div className="middle-container">
      </div>
    </div>
  );
};

export default Home;
